import { COMPLETE_INITIALIZATION, START_INITIALIZATION } from '../actionConstants/eventConstants';

export const startInitialization = () => ({ type: START_INITIALIZATION });
export const completeInitialization = () => ({ type: COMPLETE_INITIALIZATION });
